<template>
  <p>
    The Benchmark Sustainability Index is a composite index that benchmarks
    {{ marketNameLower }} companies based on their degree of ESG transparency
    and performance. All {{ marketNameLower }} companies have been included in
    this Index and scored on {{ indicators }} indicators highlighting the most
    pressing topics of concern. Separate Environment, Social and Governance
    scores are calculated, along with an overarching composite ESG score, for
    each company in the upstream {{ marketNameLower }} supply chain. Companies
    are classified into four categories based on their performance: "Industry
    Leading", "Good Practice", "Moderate Visibility" and "Limited Visibility".
  </p>
</template>

<script setup lang="ts">
import {
  COBALT,
  LITHIUM,
  NATURAL_GRAPHITE,
  NICKEL,
  RARE_EARTHS,
  SYNTHETIC_GRAPHITE,
} from '~/constants/services/constants'
import type { TMarketServiceConfig } from '~/src/types/markets'

const props = defineProps<{
  market: TMarketServiceConfig
}>()

const marketNameLower = props.market.name.toLowerCase() ?? ''
let indicators: number | string = ''

try {
  indicators = {
    [COBALT.slug]: 87,
    [NICKEL.slug]: 87,
    [LITHIUM.slug]: 87,
    [NATURAL_GRAPHITE.slug]: 87,
    [SYNTHETIC_GRAPHITE.slug]: 87,
    [RARE_EARTHS.slug]: 87,
  }[props.market.slug]
} catch (error) {
  logError(error)
}
</script>
